// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { jobsie as baseJobsieTheme } from "@stepstone-genesis/design-tokens";
var jobsie = extendBaseTheme("jobsie", baseJobsieTheme);
export {
  jobsie
};
